function DashboardNavbar() {
    return (
      <header className="bg-white shadow p-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Admin Dashboard</h1>
        {/* You can add a profile dropdown or logout here */}
      </header>
    );
  }
  
  export default DashboardNavbar;
  